'use client'
import cl from 'clsx'
import Button from '@/ui/button'
import Title from '@/ui/title'
import Link from 'next/link'
import { ScrollPanel } from 'primereact/scrollpanel'

import styles from './styles.module.css'
import './styles.css'

export default function How({ dict }) {
    const {
        title,
        title_sm,
        description,
        about_us_label
    } = dict.how

    return (
        <section id="how" className={styles.how} data-name="how">
            <div className={cl(styles.how__content_wrapper, 'container')}>
                <div className={styles.how__content}>
                    <Title
                        titleSm={title_sm}
                        title={title}
                        color="white"
                        position="how"
                    />

                    <div className={styles.how__description_wrapper}>
                        <div className={styles.how__description_wrapper_content}>
                            <ScrollPanel style={{ width: '100%', height: '300px' }} className="custombar2">
                                <div className={styles.how__description_block}>
                                    <p className={styles.how__description}>{description}</p>
                                </div>
                            </ScrollPanel>
                        </div>

                        <div className={styles.how__buttons_wrapper}>
                            <Link href="https://ic-ces.at/about/" target="_blank">
                                <Button type="how-arrow" externalText={about_us_label} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.how__video_overlay}></div>

            <video
                className={styles.how_video}
                width="320"
                height="240"
                controls={false}
                preload="none"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src="/video/how.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </section>
    )
}
